import { Select, message } from "antd";
import axios from "axios";
import type from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { showAlert } from "../components/alert/action";
import { SPORTS } from "../enums";
import { history } from "../history";

/**
 * Check component is required authentication or not
 * @param {Component} ComposedComponent
 */
export function requiredAuth(ComposedComponent) {
	class Authenticate extends Component {
		UNSAFE_componentWillMount() {
			if (!this.props.isAuthenticated) {
				history.push("/");
			}
		}

		UNSAFE_componentWillUpdate(nextProps) {
			if (!nextProps.isAuthenticated) {
				history.push("/");
			}
		}

		render() {
			return <ComposedComponent {...this.props} />;
		}
	}

	Authenticate.propTypes = {
		isAuthenticated: type.bool,
	};

	function mapStateToProps(state) {
		return {
			isAuthenticated:
				state.auth.user && state.auth.user.token && state.auth.user.token != ""
					? true
					: false,
		};
	}

	return connect(mapStateToProps)(Authenticate);
}

/**
 * Refresh auth token
 * TODO
 */
export function refreshToken() {}

/**
 * Log Type enums
 */
export const LOG_TYPE = {
	"ERROR": "Error",
	"WARNING": "Warning",
	"INFO": "Info",
};

/**
 * Save logs message into the localstorage
 * All logs send to api periodically
 * @param {String} type Log type
 * @param {LOG_TYPE} msg Message
 */
export function log(type, msg) {
	let messages = localStorage.getItem("logs");
	if (!messages) {
		messages = [];
	} else {
		messages = JSON.parse(messages);
	}
	messages.push({ type, msg });
	localStorage.setItem("logs", JSON.stringify(messages));
}

/**
 * Starts an interval for send the logs to the API
 */
export function logTimer() {
	setInterval(() => {
		let messages = localStorage.getItem("logs");
		if (messages) {
			messages = JSON.parse(messages);
			axios.post("/api/log", messages);
			localStorage.removeItem("logs");
		}
	}, 1000);
}

export function getUser() {
	let data = localStorage.getItem("user_data");
	if (data) {
		return JSON.parse(data);
	}
	return null;
}

export function setUser(user) {
	let userToAssign = user;
	if (userToAssign && userToAssign.username) {
		userToAssign.username = user.username.toLowerCase();
	}

	const existingUser = localStorage.getItem("user_data");
	if (existingUser) {
		const parsedExistingUser = JSON.parse(existingUser);
		if (
			parsedExistingUser.updateProfile !== undefined &&
			userToAssign.updateProfile === undefined
		) {
			userToAssign.updateProfile = parsedExistingUser.updateProfile;
		}
	}

	localStorage.setItem("user_data", JSON.stringify(userToAssign));
}

export function removeUser() {
	localStorage.removeItem("user_data");
	localStorage.removeItem("bets");
	localStorage.removeItem("currency");
}

export function getBets() {
	let bets = localStorage.getItem("bets");
	if (bets) {
		bets = JSON.parse(bets);
	} else {
		return [];
	}
	return bets;
}

export function beforeUpload(store, file) {
	const isJPG = file.type === "image/jpeg";
	const isPNG = file.type === "image/png";
	const isBMP = file.type === "image/bmp";
	const isPDF = file.type === "application/pdf";
	if (isJPG || isPNG || isPDF || isBMP) {
		const isLt2M = file.size / 1024 / 1024 < 5;
		if (!isLt2M) {
			store.dispatch(
				showAlert({
					type: "error",
					msg: "IMAGE_SMALLER_2MB",
					title: "ERROR",
				})
			);
			return false;
		}
		return true;
	} else {
		store.dispatch(
			showAlert({
				type: "error",
				msg: "JUST_UPLOAD_TYPES",
				title: "ERROR",
			})
		);
		return false;
	}
}

export function getBase64(file, callback) {
	const reader = new FileReader();
	reader.addEventListener("load", () => callback(reader.result));
	reader.readAsDataURL(file);
}
export function getLocalStorageItems(storeName) {
	let data = localStorage.getItem(storeName);
	if (data != "undefined" && data) {
		return JSON.parse(data);
	}
	return [];
}

export const isIos = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	return /iphone|ipad|ipod/.test(userAgent);
};

export const reloadIframe = (iframeId) => {
	const el = document.getElementById(iframeId);
	const src = el.src;
	el.src = "";
	setTimeout(() => {
		el.src = src;
	});
};

export const toggleFullIframeScreenIos = (frame) => {
	console.debug("frame", frame);
	const elHtml = document.querySelector("html");
	const elbody = document.querySelector("body");
	const elToggle = document.querySelector(".toggle-off-icon");
	const elWrapper = document.querySelector(".app-wrapper .wrapper-main");
	const elFrame = document.querySelector("#game-frame");
	if (elHtml.classList.contains("iframe-fullscreen-ios")) {
		elHtml.classList.remove("iframe-fullscreen-ios");
		elbody.classList.remove("iframe-fullscreen-ios");
		elFrame?.classList?.remove?.("iframe-fullscreen-ios");
		elWrapper?.classList?.remove?.("iframe-fullscreen-ios");
		elToggle?.classList?.remove?.("iframe-fullscreen-ios");
		elWrapper?.webkitExitFullscreen?.();
		//reloadIframe(frame);
	} else {
		elHtml.classList.add("iframe-fullscreen-ios");
		elbody.classList.add("iframe-fullscreen-ios");
		elFrame?.classList?.add?.("iframe-fullscreen-ios");
		elWrapper?.classList?.add?.("iframe-fullscreen-ios");
		elToggle?.classList?.add?.("iframe-fullscreen-ios");
		elWrapper?.webkitRequestFullscreen?.();
		//reloadIframe(frame);
	}
};

export function dateOptions(end, start = 0) {
	return Array(end - start)
		.fill()
		.map((x, i) => (
			<Select.Option
				key={i}
				value={(start + i + 1).toString().padStart(2, "0")}>
				{(start + i + 1).toString().padStart(2, "0")}
			</Select.Option>
		));
}

export function getDetail(allowedTargets, item) {
	if (allowedTargets.length === 1) {
		let target = allowedTargets[0];
		try {
			switch (target) {
				case "wiseodds": {
					let types =
						item.limits.wiseodds &&
						item.limits.wiseodds.gameTypes &&
						item.limits.wiseodds.gameTypes.length > 0
							? item.limits.wiseodds.gameTypes
							: null;
					return `${types ? " | " + types.join(", ") : ""}`;
				}
				case "casino": {
					let games =
							item.limits.casino &&
							item.limits.casino.games &&
							item.limits.casino.games.length > 0
								? item.limits.casino.games
								: null,
						providers =
							item.limits.casino &&
							item.limits.casino.providers &&
							item.limits.casino.providers.length > 0
								? item.limits.casino.providers
								: null;
					return `${
						providers ? " | " + providers.map((i) => i.toUpperCase()).join(", ") : ""
					} ${
						games ? " |" + games.map((i) => i.remote_name.toUpperCase()).join(", ") : ""
					}`;
				}
				case "liveCasino": {
					let games =
							item.limits.liveCasino &&
							item.limits.liveCasino.games &&
							item.limits.liveCasino.games.length > 0
								? item.limits.liveCasino.games
								: null,
						providers =
							item.limits.liveCasino &&
							item.limits.liveCasino.providers &&
							item.limits.liveCasino.providers.length > 0
								? item.limits.liveCasino.providers
								: null;
					return `${
						providers ? " | " + providers.map((i) => i.toUpperCase()).join(", ") : ""
					} ${
						games ? " |" + games.map((i) => i.remote_name.toUpperCase()).join(", ") : ""
					}`;
				}
				case "sportsbook": {
					let sports =
							item.limits.sportsbook &&
							item.limits.sportsbook.sportEvents &&
							item.limits.sportsbook.sportEvents.length > 0
								? item.limits.sportsbook.sportEvents
								: null,
						categories =
							item.limits.sportsbook &&
							item.limits.sportsbook.categories &&
							item.limits.sportsbook.categories.length > 0
								? item.limits.sportsbook.categories
								: null,
						tournaments =
							item.limits.sportsbook &&
							item.limits.sportsbook.tournaments &&
							item.limits.sportsbook.tournaments.length > 0
								? item.limits.sportsbook.tournaments
								: null;
					return `${
						sports ? " | " + sports.map((i) => i.name.toUpperCase()).join(", ") : ""
					} ${
						categories
							? " |" + categories.map((i) => i.name.toUpperCase()).join(", ")
							: ""
					} ${
						tournaments
							? " |" + tournaments.map((i) => i.name.toUpperCase()).join(", ")
							: ""
					}`;
				}
			}
		} catch (e) {
			console.error("Error while getting detail", e.message);
		}
	}
}

/**
 * Reduce name length
 * @param {String} text
 * @returns {String}
 */
export const textTrimmer = (text, length = 20) => {
	if (text && text.length > length) {
		const charCountRemove = text.length - length,
			charCountRemoveFromEnd = Math.round(charCountRemove / 2),
			charCountRemoveFromStart = charCountRemove - charCountRemoveFromEnd,
			midPoint = Math.round(text.length / 2),
			firstPart = text.substring(0, midPoint - charCountRemoveFromStart - 1),
			secondPart = text.substring(midPoint + charCountRemoveFromStart + 2, text.length);
		return `${firstPart}...${secondPart}`;
	}
	return text || "";
};

export const hideText = (text, length = 2) => {
	if (!text) {
		return "";
	}
	return `${text.slice(0, length)}...${text.slice(-1 * length)}`;
};
export const createPathName = (path) => {
	if (!path) {
		return "";
	}
	if (path === "/") {
		return "home";
	} else {
		return path.substring(1).replaceAll("/", "-");
	}
};

export const getSportNameById = (id, t) => {
	return t(SPORTS[id]);
};

export function excludeTenantPrefix(inputData) {
	try {
		if (inputData === undefined || inputData.indexOf("#") === -1) {
			return inputData;
		}
		let splitData = inputData.split("#");
		let splitDataLength = splitData.length;
		return splitDataLength > 1 ? splitData.slice(1, splitDataLength).join("#") : splitData;
	} catch (e) {
		console.info("No data for spliting");
		return "";
	}
}

export function convertImageToWhite(url, callback) {
	const img = new Image();
	img.crossOrigin = "Anonymous"; // prevent cors

	img.onload = function () {
		const canvas = document.createElement("canvas");
		const ctx = canvas.getContext("2d");

		canvas.width = img.width;
		canvas.height = img.height;
		ctx.drawImage(img, 0, 0);

		const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
		const data = imageData.data;

		for (let i = 0; i < data.length; i += 4) {
			const r = data[i];
			const g = data[i + 1];
			const b = data[i + 2];

			// Beyaza yakın renkler için eşiği belirleyin
			if (r > 200 && g > 200 && b > 200) {
				// Beyaz bırak
				data[i] = 255;
				data[i + 1] = 255;
				data[i + 2] = 255;
			} else {
				// Diğer renkleri beyaza dönüştür
				data[i] = 255;
				data[i + 1] = 255;
				data[i + 2] = 255;
			}
		}

		ctx.putImageData(imageData, 0, 0);

		const dataURL = canvas.toDataURL();
		callback(dataURL);
	};

	img.src = url;
}

export function createQueryStringParams(params) {
	let queryString = "";
	if (params) {
		queryString = Object.keys(params)
			.map((key) => key + "=" + encodeURIComponent(params[key]))
			.join("&");
	}
	return `?${queryString}`;
}

export function getQueryStringParams(query, key) {
	let params = new URLSearchParams(query);
	return params.get(key);
}

//number abbreviator without floor with format
// 1000000 => 1M, 10203,32 => 10.2K, 989384 => 989K
/**
 * Abbreviates a number with a given format.
 * @param {number} value The number to abbreviate.
 * @param {string} format The format string. Default is "0.00a".
 * @returns {string} The abbreviated number.
 */
export function abbreviateNumber(value, format = "0.0a") {
	// Determine the number of decimal places based on the format string
	const formatMatch = format.match(/\.(\d*)a/);
	const decimalPlaces = formatMatch ? formatMatch[1].length : 0;

	let newValue;
	let divisor;
	let suffix;

	if (value >= 1000000) {
		divisor = 1000000;
		suffix = "M";
	} else if (value >= 1000) {
		divisor = 1000;
		suffix = "K";
	} else {
		divisor = 1;
		suffix = "";
	}

	newValue = (value / divisor).toFixed(decimalPlaces) + suffix;

	// Remove unnecessary trailing zeros and decimal point if no decimals
	if (decimalPlaces === 0 || parseFloat(newValue) % 1 === 0) {
		newValue = parseInt(newValue).toString() + suffix;
	}

	return newValue;
}

//Get currency symbol
export function getCurrencySymbol(currency) {
	switch (currency) {
		case "EUR":
			return "€";
		case "USD":
			return "$";
		case "TRY":
			return "₺";
		case "GBP":
			return "£";
		case "RUB":
			return "₽";
		case "BTC":
			return "₿";
		case "ETH":
			return "Ξ";
		case "LTC":
			return "Ł";
		case "BCH":
			return "₿";
		case "XRP":
			return "₿";
		case "USDT":
			return "$";
		case "BRL":
			return "R$";
		default:
			return "";
	}
}

export const debounce = (func, delay) => {
	let timeoutId;
	return (...args) => {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => func(...args), delay);
	};
};

export const copyToClipboard = async (text, translate) => {
	try {
		await navigator.clipboard.writeText(text);
		message.success(translate("COPY_SUCCESS"));
	} catch (err) {
		message.error(translate("COPY_FAILD"));
	}
};

export const getIsoLangCode = (lang) => {
	switch (lang) {
		case "en":
			return "en-US";
		case "tr":
			return "tr-TR";
		case "de":
			return "de-DE";
		case "ru":
			return "ru-RU";
		case "es":
			return "es-ES";
		case "fr":
			return "fr-FR";
		case "it":
			return "it-IT";
		case "pt":
			return "pt-PT";
		case "br":
			return "pt-BR";
		case "ja":
			return "ja-JP";
		case "ko":
			return "ko-KR";
		case "zh":
			return "zh-CN";
		default:
			return "en-US";
	}
};

export const currencyMap = {
	"TRY": "tr-TR",
	"EUR": "de-DE",
	"USD": "en-US",
	"GBP": "en-GB",
	"RUB": "ru-RU",
	"BRL": "pt-BR",
	"MXN": "es-MX",
	"ARS": "es-AR",
	"CLP": "es-CL",
	"COP": "es-CO",
	"PEN": "es-PE",
	"UYU": "es-UY",
	"VEF": "es-VE",
	"VES": "es-VE",
	"BTC": "en-US",
	"ETH": "en-US",
	"LTC": "en-US",
	"BCH": "en-US",
	"XRP": "en-US",
	"USDT": "en-US",
	"JPY": "ja-JP",
	"CNY": "zh-CN",
	"KRW": "ko-KR",
	"INR": "en-IN",
	"CAD": "en-CA",
	"AUD": "en-AU",
	"CHF": "de-CH",
	"PLN": "pl-PL",
	"ZAR": "en-ZA",
	"ILS": "he-IL",
	"SAR": "ar-SA",
	"AED": "ar-AE",
	"SGD": "en-SG",
	"HKD": "zh-HK",
	"THB": "th-TH",
	"IDR": "id-ID",
	"MYR": "ms-MY",
	"PHP": "en-PH",
	"EGP": "ar-EG",
	"DKK": "da-DK",
	"NOK": "nb-NO",
	"SEK": "sv-SE",
	"NZD": "en-NZ",
	"BGN": "bg-BG",
	"CZK": "cs-CZ",
	"HUF": "hu-HU",
	"RON": "ro-RO",
	"HRK": "hr-HR",
	"MDL": "ro-MD",
	"UAH": "uk-UA",
	"GEL": "ka-GE",
	"AZN": "az-Latn-AZ",
	"KZT": "kk-KZ",
	"BYN": "be-BY",
	"AMD": "hy-AM",
	"UZS": "uz-Latn-UZ",
	"QAR": "ar-QA",
	"KWD": "ar-KW",
	"BHD": "ar-BH",
	"OMR": "ar-OM",
	"JOD": "ar-JO",
	"LBP": "ar-LB",
	"TND": "ar-TN",
	"DZD": "ar-DZ",
	"MRU": "ar-MR",
	"SDG": "ar-SD",
	"IQD": "ar-IQ",
	"SYP": "ar-SY",
	"YER": "ar-YE",
	"MAD": "ar-MA",
	"TWD": "zh-TW",
	"VND": "vi-VN",
	"PKR": "en-PK",
	"BDT": "bn-BD",
	"LKR": "si-LK",
	"MMK": "my-MM",
	"KHR": "km-KH",
	"LAK": "lo-LA",
};
